function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M269.2 155.8L248 113.2V85h-92.1V35.4c0-7.8-6.3-14.2-14.2-14.2-7.8 0-14.2 6.3-14.2 14.2V85H35.4v28.3h.1l-21.3 42.5H0v14.3c0 7.7 5.7 14.1 12.7 14.1h59.7c7 0 12.7-6.3 12.7-14.1v-14.3H70.7l-21.1-42.5h77.9v120.6h-35v28.3h98.8v-28.3h-35.4V113.3H234l-21.3 42.5h-14.3v14.3c0 7.7 5.7 14.1 12.7 14.1h59.7c7 0 12.7-6.3 12.7-14.1v-14.3h-14.3zm-239 0l12.4-24.9 12.3 24.9H30.2zM241 130.9l12.3 24.9h-24.8l12.5-24.9z"
})));